module.exports = __webpack_public_path__ + "img/jdangao.3f65436b.gif";